import React from 'react';

export interface VoxelDialogContentProps {
  className?: string;
  classMinWidth?: string;
}

export const VoxelDialogContent: React.FC<VoxelDialogContentProps> = ({
  children,
  className,
  classMinWidth = 'min-w-[384px]',
}) => {
  return <div className={`px-8 pb-8 ${classMinWidth} ${className}`}>{children}</div>;
};

export default VoxelDialogContent;
